<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import FolderFileSection from "./components/FolderFileSection/FolderFileSection.vue";
import axios from "axios";
import { eventBus } from '../../../Pages/assets/eventBus.js'
import Sidebar from '../document-manager/components/Sidebar/Sidebar.vue'

export default {
    components: { Layout, PageHeader, FolderFileSection, Sidebar },
    data() {
        return {
            title: "Shared Document Manager",
            items: [
                {
                    text: "Apps",
                    href: "/",
                },
                {
                    text: "Shared Document Manager",
                    active: true,
                },
            ],
            myFolders: [],
            recentFiles: [],
            sidebarFolders: [],
            folderIdsArray: [],
            searchValue: null
        };
    },
    computed: {
        // Example Admin, Enterprise Partner, Tax Company, Tax Payer
        browserTitle() {
            return this.$page.props.auth.user.user_type_text + ' - Document Manager';
        },
        // Example admin, sb, tc, tp
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
    },
    created() {
        this.searchValue = null
        this.fetchingSidebarFolders()
        eventBus.documentManagerLoading('Folder', true);
        eventBus.documentManagerLoading('File', true);
        let fetchingDataRoute = route(this.userTypeAbbr + '-shared-folders-files');
        this.fetchingData(fetchingDataRoute, 'Normal');

        eventBus.$off('searchFoldersFiles')
        eventBus.$on('searchFoldersFiles', (value) => {
            eventBus.documentManagerLoading('Folder', true);
            eventBus.documentManagerLoading('File', true);
            fetchingDataRoute = this.manageFetchingDataRoute(fetchingDataRoute, 'search', value)
            this.fetchingData(fetchingDataRoute, 'Search');
            eventBus.sideBarLoading(true);
            this.searchValue = value;
            this.fetchingSidebarFolders(value)
        });

        eventBus.$off('sortingColumn')
        eventBus.$on('sortingColumn', (datas) => {
            fetchingDataRoute = this.manageFetchingDataRoute(fetchingDataRoute, datas.item, datas.value)
            this.fetchingData(fetchingDataRoute, 'Sort');
        });

        eventBus.$off('reloadFolderFile')
        eventBus.$on('reloadFolderFile', (value) => {
            this.fetchingData(fetchingDataRoute, value.valuecheck, value.typecheck);
        });
    },
    methods: {
        manageFetchingDataRoute(fetchingDataRoute, param, paramValue) {
            let baseURL = fetchingDataRoute.split("?");
            let routeStringParam = {}
            if(baseURL.length > 1) {
                let allParam = baseURL[1].split("&")
                let strings = null;
                for(let i = 0; i < allParam.length; i++) {
                    strings = allParam[i].split("=")
                    routeStringParam[strings[0]] = strings[1]
                }
            }
            routeStringParam[param] = paramValue
            return route(this.userTypeAbbr + '-shared-folders-files', [routeStringParam]);
        },

        fetchingData(url, fetchingType, dataType = 'default') {
            axios.get(url, {
            })
            .then(response => {
                eventBus.documentManagerLoading('Folder', false);
                eventBus.documentManagerLoading('File', false);
                this.myFolders = response.data.myFolders
                this.recentFiles = response.data.recentFiles
                this.triggerOnMounted(fetchingType, dataType)
            })
            .catch(errors => {
                eventBus.documentManagerLoading('Folder', false);
                eventBus.documentManagerLoading('File', false);
                this.$toastr.e(errors.message);
            });
        },
        triggerOnMounted(type, dataType) {
            if(type === 'Search') {
                this.$refs.FolderFileSection.onMounted('search', 'default')
            }
            else if(type === 'Delete') {
                this.fetchingSidebarFolders(this.searchValue)
                setTimeout(() => {
                    this.$refs.FolderFileSection.onMounted('delete', dataType)
                },200);
            }
            else if(type === 'Add') {
                this.fetchingSidebarFolders(this.searchValue)
                setTimeout(() => {
                    this.$refs.FolderFileSection.onMounted('add', dataType)
                },200);
            }
            else if(type === 'Rename') {
                    this.fetchingSidebarFolders(this.searchValue)
            }
            else if(type === 'Protect') {
                this.fetchingSidebarFolders(this.searchValue)
            }
            else if(type === 'Unprotect') {
                this.fetchingSidebarFolders(this.searchValue)
            }
            else if (type === 'Reload') {
                this.fetchingSidebarFolders(this.searchValue)
            }
        },
        fetchingSidebarFolders(value = null) {
            let Url = route(this.userTypeAbbr + '-get-document-sidebar-folders',  {type: 'shared'})
            if(value != null) {
                Url = route(this.userTypeAbbr + '-get-document-sidebar-folders', ['shared', {search: value}])
            }
            axios.get(Url, {
            })
            .then(response => {
                this.sidebarFolders = response.data
                eventBus.sideBarLoading(false);
            });
        },
    }
};
</script>

<template>
    <Layout>
        <Head :title="browserTitle" />
        <PageHeader :title="title" :items="items" />
        <div class="d-xl-flex">
            <div class="w-100">
                <div class="d-md-flex">
                    <Sidebar 
                        :sidebarFolders="sidebarFolders"
                        :folderIdsArray="folderIdsArray"
                        dataType="Shared"
                        folderType="Shared"
                    />
                    <div class="w-100">
                        <FolderFileSection ref="FolderFileSection"
                            :myFolders="myFolders" 
                            :recentFiles="recentFiles"
                            folderTitle="Shared Folders"
                            fileTitle="Recent Shared Files"
                            folderType="Shared"
                            fileType="Shared"
                            noDataFolderTitle="No Shared Folders Available."
                            noDataFileTitle="No Shared Files Available."
                            routeType="Shared"
                        />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
